import styled from 'styled-components';

const ActionWrapper = styled.div`
  margin-top: 39px;
`;

export default ActionWrapper;
